export const formatDate = (locale: string, dateStr: string) => {
  const date = new Date(dateStr)
  return date.toLocaleDateString(locale, { month: 'short', day: 'numeric', weekday: 'short' })
}
